module.exports = __webpack_public_path__ + "img/inge-v9-4.3c12c80a.png";